<script setup lang="ts">
import {BackingInterviewStep} from "@/backing/interfaces/backing";
import BackingInterview from "@/backing/components/BackingInterview.vue";
import {useRoute, useRouter} from "vue-router";

const router = useRouter();
const route = useRoute();
defineProps<{
    interviewSteps: BackingInterviewStep[]
    interviewId: number,
}>();

/**
 * Start a new interview instance.
 *
 * @param step
 * @param {number|undefined} instanceId If not provided, a new instance will be created.
 */
const goToInstance = (step: BackingInterviewStep, instanceId?: number) => {
    router.replace({
        name: 'interview-instances',
        query: {
            ...route.query,
            interviewId: step.resource_id,
            interviewInstanceId: instanceId ?? undefined,
            interviewName: step.name,
        }
    });
};
</script>

<template>
  <div class="space-y-2">
    <div v-if="interviewSteps.length" class="flex flex-col gap-2">
      <BackingInterview
        v-for="step in interviewSteps"
        :key="step.resource_id"
        :step="step"
        @start-instance="goToInstance(step)"
        @view-instance="instanceId => goToInstance(step, instanceId)"
      />
    </div>
    <div v-else>
      <p>Aucun autre entretien n'est disponible</p>
    </div>
  </div>
</template>
